import { MessageCircle } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToId, WA_LINK } from "@/lib/scroll";

export default function FinalCTA() {
    return (
        <section className="noise-overlay relative overflow-hidden py-24 lg:py-36" data-testid="final-cta-section">
            <div className="grid-lines absolute inset-0 opacity-50" />
            <div className="absolute left-1/2 top-1/2 h-[420px] w-[420px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-[#00C6FF]/15" />
            <div className="orbit-ring absolute left-1/2 top-1/2 h-[560px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-dashed border-[#00C6FF]/10" />
            <div className="absolute left-1/2 top-1/2 h-72 w-72 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00C6FF]/10 blur-[110px]" />

            <div className="relative z-10 mx-auto max-w-4xl px-4 text-center sm:px-6">
                <Reveal>
                    <p className="font-mono-accent text-xs uppercase tracking-[0.4em] text-[#00C6FF]">
                        360° Experiences Starting From ₹4,999
                    </p>
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="text-glow mt-6 text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
                        READY TO LET CUSTOMERS{" "}
                        <span className="bg-gradient-to-r from-[#00C6FF] to-[#0072FF] bg-clip-text text-transparent">
                            STEP INSIDE?
                        </span>
                    </h2>
                </Reveal>
                <Reveal delay={0.2}>
                    <p className="mx-auto mt-6 max-w-xl text-base text-slate-300 sm:text-lg">
                        Your next customer is online right now, deciding where to go.
                        Let them step inside your space tonight.
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
                        <a
                            data-testid="final-cta-whatsapp-btn"
                            href={WA_LINK}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cta-glow flex items-center gap-2.5 rounded-full bg-[#00C6FF] px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-[#050B14] transition-transform duration-300 hover:scale-105"
                        >
                            <MessageCircle size={17} />
                            Get My 360° Tour
                        </a>
                        <button
                            data-testid="final-cta-quote-btn"
                            onClick={() => scrollToId("contact")}
                            className="rounded-full border border-[#00C6FF]/50 px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-[#00C6FF] transition-colors duration-300 hover:bg-[#00C6FF]/10"
                        >
                            Request Custom Quote
                        </button>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
